import clsx from 'clsx'
import {FC, PropsWithChildren, useMemo} from 'react'
import {HeaderProps} from 'react-table'
import {initialQueryState} from '../../../../../../_metronic/helpers'
import {useQueryRequest} from '../../core/QueryRequestProvider'
import {Judol} from '../../core/_models'

type Props = {
  className?: string
  title?: string
  tableProps: PropsWithChildren<HeaderProps<Judol>>
  enableSort: boolean
  stickyEnd?: number
  stickyBg?: string
  stickyBorder?: boolean
}
const JudolCustomHeader: FC<Props> = ({
  className,
  title,
  tableProps,
  enableSort = false,
  stickyEnd,
  stickyBg,
  stickyBorder = false,
}) => {
  const id = tableProps.column.id
  const {state, updateState} = useQueryRequest()

  const isSelectedForSorting = useMemo(() => {
    return state.sortName && state.sortName === id
  }, [state, id])
  const sortDir: 'asc' | 'desc' | undefined = useMemo(() => state.sortDir, [state])

  const sortNameColumn = () => {
    // avoid sortNameing for these columns
    if (id === 'actions' || id === 'selection') {
      return
    }

    if (!isSelectedForSorting) {
      // enable sortName asc
      updateState({sortName: id, sortDir: 'asc', ...initialQueryState})
      return
    }

    if (isSelectedForSorting && sortDir !== undefined) {
      if (sortDir === 'asc') {
        // enable sortName desc
        updateState({sortName: id, sortDir: 'desc', ...initialQueryState})
        return
      }

      // disable sortName
      updateState({sortName: undefined, sortDir: undefined, ...initialQueryState})
    }
  }

  return (
    <th
      {...tableProps.column.getHeaderProps()}
      className={clsx(
        className,
        enableSort && 'cursor-pointer',
        isSelectedForSorting && sortDir !== undefined
          ? `table-sort-${sortDir === 'asc' ? 'asc' : 'desc'}`
          : enableSort && 'table-can-sort'
      )}
      style={
        stickyEnd !== undefined
          ? {
              position: 'sticky',
              right: `${stickyEnd}px`,
              background: stickyBg || 'white',
              borderLeft: stickyBorder ? 'solid 1px rgba(0, 0, 0, 0.2)' : 'unset',
            }
          : undefined
      }
      onClick={enableSort ? sortNameColumn : undefined}
    >
      {title}
    </th>
  )
}

export {JudolCustomHeader}
